"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
/**
 * A function to replace tokens in square brackets by the result of corresponding functions. The result
 * is an array containing the chunked original string, and the replacement values.
 *
 * An example use case is injecting anchors into localized string. ex:
 *
 * String: "[USER_NAME]" shared this workbook.
 *                |
 *                |      Interpolated String
 *                v
 * <span>
 *    <a href="username.html">User Name</a>
 * </span> shared this workbook.
 *
 * Usage:
 * 1. Define base string with square brackets
 *     sharedWithMe = "[USER_NAME] shared this workbook."
 * 2. Define replacement functions which will be used to re-place the tokens in string i.e.
 *     [USER_NAME]  --replaced with-->  <span><a href="username.html">User Name</a></span>
 *
 *       const replacements = {
 *        'USER_NAME': () => (
 *          <span>
 *            <a href="username.html">User Name</a>
 *          </span>)
 *      };
 * 3. Get interpolateString using baseString (#1) and replacements (#2)
 *      {interpolateString(sharedWithMe, replacements)}
 *
 * @param baseString - A string containing tokens surrounded by square brackets
 * @param replacements - a {@link Replacements} instance where the keys are the tokens, and the values either {@link ReplacementValue} or
 *                       functions that return replacement values
 */
function interpolateString(baseString, replacements) {
    var result = [];
    // generate replacements and order them
    var replacementsInOrder = _.chain(Object.keys(replacements))
        .map(function (k) { return findInString(baseString, k); }) // find occurrences and flatten them
        .flatten()
        .filter(function (v) { return v.start >= 0; }) // filter out patterns not present in the string
        .sortBy('start') // sort by start index
        .map(function (v, index) { return replace(v, replacements, index); }) // map found values to their replacement, passing their index
        .value();
    // iterate through replacements, chunk the base string and add it to the result
    var subStringIndex = 0;
    replacementsInOrder.forEach(function (rep) {
        if (rep.start !== subStringIndex) {
            var subString = baseString.substring(subStringIndex, rep.start);
            var wrapped = subString;
            result.push(wrapped);
        }
        result.push(rep.value);
        subStringIndex = rep.end + 1;
    });
    // if there is a trailing chunk, add it as well
    if (subStringIndex < baseString.length) {
        var lastChunk = baseString.substring(subStringIndex);
        var wrapped = lastChunk;
        result.push(wrapped);
    }
    return result;
}
exports.interpolateString = interpolateString;
/**
 * Find occurrences of a key in the base string.
 * @param baseString - The string to search
 * @param key - the key to replace. Only occurrences surrounded by square brackets are considered
 */
function findInString(baseString, key) {
    var searchStart = -1;
    var result = [];
    var keyWithBrackets = "[" + key + "]";
    var index = -1;
    do {
        index = baseString.indexOf(keyWithBrackets, searchStart);
        var val = {
            start: index,
            end: index + keyWithBrackets.length - 1,
            key: key
        };
        result.push(val);
        searchStart = val.end;
    } while (index > -1);
    return result;
}
/**
 * replace a found value with the corresponding function, passing the index into that function
 * @param foundValue - a value with a key, start, and end indices.
 * @param replacements - a {@link Replacements} instance containing replacement functions / values
 * @param index - the index of the found value
 */
function replace(foundValue, replacements, index) {
    var rep = replacements[foundValue.key];
    foundValue.value = typeof rep === 'function' ? rep(index) : rep;
    return foundValue;
}
//# sourceMappingURL=StringInterpolation.js.map